import {
  Outlet,
  RouteObject,
  createBrowserRouter,
  useRouteError,
  RouterProvider,
} from 'react-router-dom';
import Error404 from '@/pages/404';
import {Lazily} from '@/components/refinedev/helpers';
import {HomeIcon} from '@heroicons/react/24/solid';
import {CatchAllNavigate} from '@refinedev/react-router-v6';
import {Authenticated} from '@refinedev/core';
import Layout2 from '@/layout/layout';

import AppSettings from '@/pages/AppSettings';
import TestReactFlow from '@/pages/test/test-react-flow';
import TestAccessControl from '@/pages/test/test-access-control';
import TestTailwind from '@/pages/test/test-tailwind';
import {RefineProvider} from './refine-provider';
import {resources} from './resources';
import Login from '@/pages/auth/login';
import Dashboard from '@/pages/dashboard/Dashboard';
import Profile from '@/pages/profile';
import TestFormSubmit from '@/pages/test/TestFormSubmit';
import JsonView from '@uiw/react-json-view';
import EditableStepEdgeFlow from '@/pages/test/test-react-flow-custom-edge';
import GeneratePDF from '@/pages/test/test-pdf';

function ErrorBoundary() {
  const error: any = useRouteError();
  // console.log(error);
  const message = error?.message || '';
  const stack: string = error?.stack || '';
  console.log('Error stack:', stack);

  // Uncaught ReferenceError: path is not defined
  return (
    <div>
      <p className="text-2xl">Lỗi đã xảy ra</p>
      <p>{message}</p>
      <div>
        {stack.split('\n').map(s => (
          <p>{s}</p>
        ))}
      </div>
      {/* {error?.stack && <JsonView value={error?.stack} />} */}
    </div>
  );
}

//// for 6.4+
const routes: RouteObject[] = [
  {
    path: '',
    Component: RefineProvider,
    // errorElement: <ErrorBoundary />,
    children: [
      // unauthenticated routes
      {
        element: <Outlet />,
        path: 'auth',
        // errorElement: <ErrorBoundary />,
        children: [
          {
            path: 'login',
            element: Lazily(Login),
          },
        ],
      },
      // Authenticated routes
      {
        path: '',
        element: (
          <Authenticated key={'authenticated'} fallback={<CatchAllNavigate to="/auth/login" />}>
            {/* <DefaultLayout sidebarProps={{title: 'SMS', sidebarMenu: adminSidebarMenuItems}} /> */}
            <Layout2 />
          </Authenticated>
        ),
        // errorElement: <ErrorBoundary />,
        handle: {
          crumb: <HomeIcon className="w-5 h-5" />,
        },
        children: [
          {
            path: '',
            element: Lazily(Dashboard),
            handle: {
              // crumb: 'Dashboard',
            },
          },
          {
            path: 'profile',
            element: Lazily(Profile),
            handle: {
              crumb: 'Profile',
            },
          },
          // resources
          ...resources.map(res => res.route),
          // settings
          {
            path: 'settings',
            element: <AppSettings />,
            handle: {
              crumb: 'Thiết lập',
            },
          },
          {
            path: 'test',
            element: <Outlet />,
            handle: {
              crumb: 'Test',
            },
            children: [
              {
                path: 'test-form-submit',
                element: Lazily(TestFormSubmit),
                handle: {
                  crumb: 'Form submit',
                },
              },
              {
                path: 'test-react-flow',
                element: Lazily(TestReactFlow),
              },
              {
                path: 'test-react-flow-custom-edge',
                element: Lazily(EditableStepEdgeFlow),
              },
              {
                path: 'test-access-control',
                element: Lazily(TestAccessControl),
              },
              {
                path: 'test-tailwind',
                element: Lazily(TestTailwind),
              },
              {
                path: 'test-pdf',
                element: Lazily(GeneratePDF),
              }
            ],
          },
        ],
      },
      //// other
      {
        path: '*',
        element: <Error404 />,
        // errorElement: <ErrorBoundary />,
      },
    ],
  },
];

// Add a wrapper React component to enable Fast Refresh
function AppRouter() {
  const appRouter = createBrowserRouter(routes, {
    basename: '/admin', /// important to have / at beginning; laravel also need to match all include / after /admin/
  });

  return <RouterProvider router={appRouter} />;
}

export default AppRouter;
